module.exports = __webpack_public_path__ + "static/img/whatsapp.5fb4e1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/whatsapp.png
// module id = s1Vd
// module chunks = 2